import { render, staticRenderFns } from "./confirm.vue?vue&type=template&id=e8225db8"
import script from "./confirm.vue?vue&type=script&lang=js"
export * from "./confirm.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./confirm.vue?vue&type=style&index=0&id=e8225db8&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "6c00cdd4"
  
)

export default component.exports